import { generateAimlabsWebAuthCode } from "./discovery.apis"

const state = {
  discoveryFlowError: null,
  navigatingUserToDiscovery: false,
}

const getters = {
  discoveryFlowError: state => state.discoveryFlowError,
  navigatingUserToDiscovery: state => state.navigatingUserToDiscovery,
}

const mutations = {
  SET_DISCOVERY_FLOW_ERROR: (state, error) => (state.discoveryFlowError = error),
  SET_NAVIGATING_FLAG: (state, isNavigating) => (state.navigatingUserToDiscovery = isNavigating),
}

const actions = {
  async navigateUserToDiscovery ({ state, commit }) {
    if (state.navigatingUserToDiscovery) {
      return
    }

    try {
      commit("SET_DISCOVERY_FLOW_ERROR", null)
      commit("SET_NAVIGATING_FLAG", true)
      const authCodeData = await generateAimlabsWebAuthCode()
      const discoveryUrl = new URL(authCodeData.redirect_uri)
      discoveryUrl.searchParams.set("accessCode", authCodeData.code)
      window.open(discoveryUrl, "_blank", "popup=1")
    } catch (e) {
      commit(
        "SET_DISCOVERY_FLOW_ERROR",
        e?.response?.data?.message ?? e.message ?? "An error occurred when starting up Discovery."
      )
    } finally {
      commit("SET_NAVIGATING_FLAG", false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/aimlabs/discovery/discovery.module.js